
                export default function (Component) {
                    Component.__source = "library/components/VabLock/index.vue"
                }
            